import qingShui from './index'
import qingShuiHome from './Home'

const dataHistory = () => import('./../../components/DataHistory')
const airStation = () => import('./airStation')
const airStationOne = () => import('./airStationOne')
const gasClamp = () => import('./gasClamp')
const bridgeImg = () => import('./bridgeImg')
const pressureFan = () => import('./pressureFan')
const login = () => import('./login.vue')

export default [
  {
    path: '/qingShuiIndex',
    name: 'qingShuiIndex',
    component: qingShuiHome
  },
  {
    path: '/qingShui/login',
    name: 'qingShuiLogin',
    component: login
  },
  {
    path: '/qingShui',
    name: 'qingShui',
    redirect: '/qingShui/saddleRoom',
    component: qingShui,
    children: [
      {
        path: 'bridgeImg',
        name: 'bridgeImg',
        component: bridgeImg
      },
      {
        path: 'gasClamp',
        name: 'gasClamp',
        component: gasClamp
      },
      {
        path: 'dataHistory',
        name: 'qsDataHistory',
        component: dataHistory
      },
      {
        path: 'airStationOne',
        name: 'airStationOne',
        component: airStation
      },
      {
        path: 'airStationTwo',
        name: 'airStationTwo',
        component: airStation
      },
      {
        path: 'airStationThree',
        name: 'airStationThree',
        component: airStation
      },
      {
        path: 'airStationFour',
        name: 'airStationFour',
        component: airStation
      },
      {
        path: 'airStationFive',
        name: 'airStationFive',
        component: airStationOne
      },
      {
        path: 'pressureFanFive',
        name: 'pressureFanFive',
        component: pressureFan
      },
      {
        path: 'airStationSix',
        name: 'airStationSix',
        component: airStationOne
      },
      {
        path: 'pressureFanSix',
        name: 'pressureFanSix',
        component: pressureFan
      }
    ]
  }
]
